import { useQuery } from '@tanstack/react-query';
import { getAxios } from 'src/lib/axios';
import { CompanyLogoModel } from '../types/CompanyLogoModel';
import { useProfileStore } from 'src/features/stores/useProfileStore';

export const useGetCompanyLogoModelQuery = (enabled: boolean) => {
  const profileStore = useProfileStore();
  const selectedUser = profileStore.users?.find((u) => u.ContactId === profileStore.selectedUserId);
  const companyId = selectedUser?.CompanyId;

  return useQuery<CompanyLogoModel>({
    queryKey: ['useGetCompanyLogoModel'],
    queryFn: async () =>
      (await getAxios().get(`/api/OnlineBookingCompanyProfile/GetCompanyLogoModel/?companyId=${companyId}`)).data,
    enabled: enabled && !!profileStore.selectedUserId // <--- only runs when selectedUserId is available.
  });
};
